
import {
    NOTIFICATION_GET_DETAILS
} from "../actions"


const INIT_STATE = {
    announcement : null,
    loading: true
};


export default (state = INIT_STATE,action) => {
    switch(action.type) {
        case NOTIFICATION_GET_DETAILS:
            return {...state,loading: false, announcement: action.payload};
        default: return { ...state };
    }
}
